import {Component, Input, input} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {formatDate, NgClass, NgForOf} from "@angular/common";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {BacklogService} from "../../../../core/services/backlog.service";
import {GeneralService} from "../../../../core/services/general.service";
import {TableService} from "../../../../core/services/table.service";

@Component({
  selector: 'app-confirm-payment',
  standalone: true,
    imports: [
        FormsModule,
        NgForOf,
        ReactiveFormsModule,
        NgClass
    ],
  templateUrl: './confirm-payment.component.html',
  styleUrl: './confirm-payment.component.scss'
})
export class ConfirmPaymentComponent {
    @Input() confirmAction!: () => void;
    @Input() data: any;
    public validate: boolean = false;
    public confirmationForm : FormGroup;
    public paymentStatusList : any = [];
    public paymentMethodList : any = [];

    constructor(public modal:NgbModal,private fb:FormBuilder, public backlogService: BacklogService, private generalService: GeneralService,private tableService: TableService) {
        this.confirmationForm = this.fb.group ({
            service_id: new FormControl(0),
            payment_status_id: new FormControl("", Validators.required),
            payment_method_id: new FormControl("", Validators.required),
            payment_date: new FormControl("")
        });
    }

    ngOnInit():void{
        this.loadList({"conditionColumn":"configurableListsField",
            "conditionValue":"Estatus de pago",
            "idColumn":"idconfigurableLists",
            "table":"confList",
            "valueColumn":"configurableListsCode"}, (value) => {
            this.paymentStatusList = value;
        });

        this.loadList({"conditionColumn":"configurableListsField",
            "conditionValue":"Métodos de pago",
            "idColumn":"idconfigurableLists",
            "table":"confList",
            "valueColumn":"configurableListsCode"}, (value) => {
            this.paymentMethodList = value;
        });
    }
    /**
     * METHODS
     */
    paymentConfirmation(){
        if (this.confirmationForm.invalid) {
            this.validate = true;
        } else {
            const now = new Date();
            const datePay = now.toISOString().split('T')[0];
            this.confirmationForm.get('service_id')?.setValue(this.data.idService);
            this.confirmationForm.get('payment_date')?.setValue(datePay);
            this.backlogService.actionBacklog(this.confirmationForm.value,'paymentconfirmation').subscribe(
                (res: any) => {
                    if (res.error) {
                        this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                    } else {
                        this.confirmationForm.reset();
                        this.generalService.showMessage('success', res.message);
                        this.confirmAction();
                    }
                },
                (err) => {
                    this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
                }
            );
        }
    }


    loadList(config: any, setVariable: (value: any) => void):void {
        this.tableService.loadSelectOptions(config).subscribe(
            (res: any) => {
                if (res.error) {
                    this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                    setVariable([]);
                } else {
                    setVariable(res['message']);
                }
            },
            (err) => {
                this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
                setVariable([]);
            }
        );
    }
    /**
     * VALIDACIONES INPUTS
     */
    get paymentStatus() {
        return this.confirmationForm.get("payment_status_id");
    }
    get methodPayment() {
        return this.confirmationForm.get("payment_method_id");
    }



}
